import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

export const fetchCountries = createAsyncThunk('countries/fetchCountries', async () => {
  const res = await axios.get('https://restcountries.com/v2/all?fields=name,region,flag');
  return res.data;
});

const countriesSlice = createSlice({
  name: 'countries',
  initialState: {
    data: [],
    filtered: [],
    region: 'All',
    visible: 12,
    status: 'idle',
  },
  reducers: {
    filterByRegion: (state, action) => {
      state.region = action.payload;
      state.visible = 12;
      state.filtered = action.payload === 'All'
        ? state.data
        : state.data.filter((c) => c.region === action.payload);
    },
    loadMore: (state) => {
      state.visible += 12;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCountries.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchCountries.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.data = action.payload;
        state.filtered = action.payload;
      });
  },
});

export const { filterByRegion, loadMore } = countriesSlice.actions;
export default countriesSlice.reducer;
